import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Api } from "../redux/api/BaseApi";
import { IAction, IActionUI } from "../types/Action/IAction";
import { IQuickNote } from "../types/Ticket/IQuickNotes";

const initialActionState = {
  ID: 0
} as IAction;

const initialUiSettings = {
  Bill_Time_Enabled: true,
  NonBill_Time_Enabled: true,
} as IActionUI;

export const PRIVATE_ACTION_ID = 7;
export type TranslatingStatus = 'idle' | 'loading' | 'success' | 'error';

const ActionSlice = createSlice({
  name: "actionDetails",
  initialState: {
    action: initialActionState,
    settings: initialUiSettings,
    translateOption: 0,
    translatingStatus: 'idle' as TranslatingStatus,
    originalNote: null as string,
  },
  reducers: {
    ResetAction: (state, action) => {
      state.action = { ...initialActionState, Action_Dt: new Date() };
      state.settings = initialUiSettings;
    },
    SetAction: (state, action: PayloadAction<IAction>) => {
      state.action = action.payload;
    },
    SetTranslatingStatus: (state, action: PayloadAction<TranslatingStatus>) => {
      state.translatingStatus = action.payload;
    },
    SetTranslationOption: (state, action: PayloadAction<number>) => {
      state.translateOption = action.payload;
    },
    SetOriginalNote: (state, action: PayloadAction<string>) => {
      state.originalNote = action.payload;
    },
    SetBill: (state, action: PayloadAction<number>) => {
      state.action.Billable_Time = action.payload;
    },
    SetNonBill: (state, action: PayloadAction<number>) => {
      state.action.Non_Billable_Time = action.payload;
    },
    SetUISettings: (state, action: PayloadAction<IActionUI>) => {
      state.settings = action.payload;
    },
    SetTaggedDescription: (state, action: PayloadAction<string>) => {
      state.action.TaggedDescription = action.payload;
    },
    SetHTML_Notes: (state, action: PayloadAction<string>) => {
      state.action.HTML_Notes = action.payload;
    },
    SetQuickNote: (state, action: PayloadAction<IQuickNote>) => {
      state.action.Quick_Note_Id = action.payload?.Id;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      //The new ticket should initially be assigned to the current user
      Api.endpoints.getUserProfile.matchFulfilled,
      (state, { payload }) => {
        console.log("Api.endpoints.getUserProfile.matchFulfilled", payload.Id);
        let actionTypeId =
          payload.Features.Private_Actions &&
            payload.Features.Private_Notes_Always_On
            ? PRIVATE_ACTION_ID
            : undefined;
        state.action = {
          ...state.action,
          Staff_Id: payload.Id,
          Billable_Time: payload.Default_Time,
          Action_Type_Id: actionTypeId,
        };
        state.settings = {
          ...state.settings,
          Bill_Time_Enabled: actionTypeId !== PRIVATE_ACTION_ID,
          NonBill_Time_Enabled: actionTypeId !== PRIVATE_ACTION_ID,
        };
      }
    );
  },
});

export const {
  SetAction,
  SetBill,
  SetNonBill,
  SetUISettings,
  ResetAction,
  SetTaggedDescription,
  SetHTML_Notes,
  SetTranslationOption,
  SetOriginalNote,
  SetQuickNote,
  SetTranslatingStatus
} = ActionSlice.actions;
export default ActionSlice.reducer;
